import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// Constants
const CURRENCY_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

// Helper functions
const formatCurrency = (amount) =>
  `₱${Number(amount || 0).toLocaleString(undefined, CURRENCY_FORMAT_OPTIONS)}`;

const getChartOptions = (title, data) => ({
  chart: { type: "pie" },
  title: { text: title },
  tooltip: {
    formatter() {
      return `<b>${this.point.name}</b><br/>
              Total Count: ${this.y}<br/>
              Total Amount: ${formatCurrency(this.point.totalAmount)}`;
    },
  },
  plotOptions: {
    pie: {
      innerSize: "40%",
      size: "100%",
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: { enabled: false },
    },
  },
  series: [{ name: title, data }],
  credits: { enabled: false },
  legend: {
    enabled: true,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
    itemMarginBottom: 8,
  },
});

const chartTitles = ["Brand", "Payment Type", "Transaction Type"];

const Charts = ({ chartRef, chartContainerId, doughnutData }) => (
  // <div
  //   ref={chartRef}
  //   id={chartContainerId}
  //   className="row row-cols-1 row-cols-md-3 g-4 mt-2"
  // >
  //   {doughnutData.map((data, index) => (
  //     <div key={index} className="col">
  //       <HighchartsReact
  //         highcharts={Highcharts}
  //         options={getChartOptions(`Chart ${index + 1}`, data)}
  //       />
  //     </div>
  //   ))}
  // </div>

  <div
    ref={chartRef}
    id={chartContainerId}
    className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mt-2"
  >
    {doughnutData.map((data, index) => (
      <div key={index} className="col">
        <div
          className="card border-0 h-100"
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            transition: "all 0.3s ease",
            overflow: "hidden",
            background: "#ffffff",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 8px 24px rgba(31, 77, 44, 0.15)";
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Card Header */}
          <div
            style={{
              padding: "16px 20px",
              borderBottom: "1px solid #f3f4f6",
              background: "linear-gradient(135deg, #f9fafb 0%, #ffffff 100%)",
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <h6
                className="mb-0 fw-semibold"
                style={{
                  color: "#1F4D2C",
                  fontSize: "0.95rem",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {data.title || `Chart ${index + 1}`}
              </h6>
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #1F4D2C 0%, #83c14a 100%)",
                  boxShadow: "0 0 8px rgba(131, 193, 74, 0.6)",
                }}
              ></div>
            </div>
          </div>

          {/* Chart Content */}
          <div style={{ padding: "20px" }}>
            <HighchartsReact
              highcharts={Highcharts}
              options={getChartOptions(chartTitles[index], data)}
            />
          </div>

          {/* Optional Footer with Stats */}
          {data.totalValue && (
            <div
              style={{
                padding: "12px 20px",
                borderTop: "1px solid #f3f4f6",
                background: "#fafafa",
              }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <small
                  style={{
                    color: "#6b7280",
                    fontSize: "0.8rem",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Total Value
                </small>
                <span
                  style={{
                    color: "#1F4D2C",
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  ₱{data.totalValue.toLocaleString()}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);

export default Charts;
